type SupportedNetwork = {
  chainId?: number | string | null;
};

export const normalizeChainId = (value: unknown): number | null => {
  if (typeof value === "number" && Number.isInteger(value) && value > 0) {
    return value;
  }

  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (!trimmed) return null;

  const parsed = trimmed.startsWith("0x")
    ? parseInt(trimmed.slice(2), 16)
    : parseInt(trimmed, 10);

  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const getSupportedNetworkChainIds = (
  supportedNetworks: SupportedNetwork[] = []
): number[] => {
  return supportedNetworks
    .map((network) => normalizeChainId(network.chainId))
    .filter((chainId): chainId is number => chainId !== null);
};

export const isSupportedNetworkChainId = (
  chainId: number | null,
  supportedChainIds: number[]
): chainId is number => {
  return chainId !== null && supportedChainIds.includes(chainId);
};
